import { render, staticRenderFns } from "./totalCount.vue?vue&type=template&id=c0264888&"
import script from "./totalCount.vue?vue&type=script&lang=js&"
export * from "./totalCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports